<template>
  <div
    class="bg-surface-default-low rounded-lg flex flex-col justify-between gap-12 p-16 md:flex-row md:items-center md:justify-center md:gap-24 md:pl-32"
  >
    <p class="heading-2">{{ label }}</p>
    <ClientOnly>
      <RevCounter
        :date
        :date-labels="counterTranslations"
        date-max-unit="weeks"
      />
      <template #fallback>
        <div class="block h-[60px] w-[176px]"></div>
      </template>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCounter } from '@ds/components/Counter'

import translations from './BlackFridayCountdown.translations'

defineProps<{
  label: string
  date: Date
}>()

const i18n = useI18n()
const counterTranslations = {
  weeks: i18n(translations.weeks),
  days: i18n(translations.days),
  hours: i18n(translations.hours),
  minutes: i18n(translations.minutes),
  seconds: i18n(translations.seconds),
}
</script>
